import styled from "@emotion/styled";

import IconButton from "@mui/material/IconButton";

export const InputIconButton = styled(IconButton)(({ theme }) => ` svg path { fill: ${theme.palette.icon} } `);
